import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { tQrFailureProps } from './QrFailure.types.ts';

export default function QrFailure(props: tQrFailureProps) {
  const { t } = useTranslation('sidebar/sidebarComponent');

  return (
    <div className="flex flex-col items-center justify-center gap-3 p-6 text-center">
      <ExclamationTriangleIcon className="h-12 w-12 text-warning" />
      <h2 className="text-lg font-semibold">
        {t('page.modals.connection.failureTitle')}
      </h2>
      <p className="text-sm text-base-content/70">
        {t('page.modals.connection.failureMessage')}
      </p>
      <button
        type="button"
        className="btn btn-primary btn-sm mt-2"
        onClick={props.onRetry}
      >
        {t('page.modals.connection.retry')}
      </button>
    </div>
  );
}
